import { LicenseInfo } from "@mui/x-license";

export const projectTypes = {
  device: 1,
  noDevice: 2,
};

export const apiPrefix = `${
  import.meta.env && import.meta.env.VITE_PMI_API_URL
    ? import.meta.env.VITE_PMI_API_URL
    : window._env_ &&
        window._env_.PMI_API_URL &&
        window._env_.PMI_API_URL !== "${VITE_PMI_API_URL}"
      ? window._env_.PMI_API_URL
      : "http://localhost:8080"
}/api/pmi`;

export const deviceApiPrefix = `${
  import.meta.env && import.meta.env.VITE_MICROSERVICES_API_URL
    ? import.meta.env.VITE_MICROSERVICES_API_URL
    : window._env_ &&
        window._env_.MICROSERVICES_API_URL &&
        window._env_.MICROSERVICES_API_URL !== "${VITE_MICROSERVICES_API_URL}"
      ? window._env_.MICROSERVICES_API_URL
      : "http://localhost:8090"
}/api/pmi_device`;

export const userApiPrefix = `${
  import.meta.env && import.meta.env.VITE_MICROSERVICES_API_URL
    ? import.meta.env.VITE_MICROSERVICES_API_URL
    : window._env_ &&
        window._env_.MICROSERVICES_API_URL &&
        window._env_.MICROSERVICES_API_URL !== "${VITE_MICROSERVICES_API_URL}"
      ? window._env_.MICROSERVICES_API_URL
      : "http://localhost:8094"
}/api/pmi_user`;

export const projectsPrefix = `${apiPrefix}/projects`;

export function sourceAsText(sourceData: Source) {
  return (
    sourceData["name"] +
    " ( schema: " +
    sourceData["schemaIdentifier"] +
    ", database: " +
    sourceData["databaseName"] +
    " )"
  );
}

export function scrollToSection(
  sectionId: string,
  options?: ScrollIntoViewOptions,
) {
  const element = document.getElementById(sectionId);
  if (!element) {
    console.error(`Cannot find element with id ${sectionId}`);
    return;
  }
  // We could use scrollIntoViewIfNeeded when is fully supported in all the browsers
  element.scrollIntoView({
    behavior: "smooth",
    block: "start",
    inline: "center",
    ...options,
  });
}

export function getDiffDaysMessage(
  diffDays: string | number | undefined | null,
) {
  let ddMessage = "";
  if (!isNumber(diffDays)) {
    return ddMessage;
  }

  diffDays = diffDays as number; // The previous check guarantees it is one now.

  if (diffDays === 0) return "Day of index";

  ddMessage += Math.abs(diffDays).toString();
  ddMessage += Math.abs(diffDays) === 1 ? " day" : " days";
  ddMessage += diffDays < 0 ? " pre-" : " post-";
  ddMessage += "index";
  return ddMessage;
}

function isNumber(value?: string | number | null): boolean {
  return (
    value !== null &&
    value !== undefined &&
    value !== "" &&
    !isNaN(Number(value.toString()))
  );
}

// This function is used in sort functions
export function compareTwoValues(
  a: null | number | boolean | string,
  b: null | number | boolean | string,
) {
  if (a === null) {
    return b === null ? 0 : 1;
  } else if (b === null) {
    return -1;
  }
  if (typeof a === "number") {
    return typeof b === "number" ? a - b : -1;
  } else if (typeof b === "number") {
    return -1;
  }
  if (typeof a === "boolean") {
    if (typeof b === "boolean") {
      return a === b ? 0 : a ? -1 : 1;
    } else {
      return -1;
    }
  } else if (typeof b === "boolean") {
    return -1;
  }
  return a.localeCompare(b, "en", { sensitivity: "base" });
}

export function setLicenseKey() {
  LicenseInfo.setLicenseKey(
    "01c452018c488cc353c57c106ac57b65Tz0xMjUzMTUsRT0xODA0NTUwMzk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y",
  );
}
